<div class="pay">
  <div class="confirmation" *ngIf="paymentComplete">
    {{ content?.fields.paymentSucceededText }}
  </div>

  <div class="error" *ngIf="paymentErrors">{{ paymentErrors }}</div>

  <h1 class="title">{{ content?.fields.title }}</h1>

  <div class="ingress">
    {{ content?.fields.ingress }}
  </div>

  <form (ngSubmit)="pay($event)" [formGroup]="paymentForm">
    <div class="billing-details">
      <div class="billing-details__field-container">
        <label for="name"
          >{{ content?.fields.name }} <span aria-hidden="true">*</span></label
        >
        <input
          id="name"
          class="billing-details__input"
          type="text"
          formControlName="name"
        />
      </div>
      <div class="billing-details__field-container">
        <label for="address"
          >{{ content?.fields.address }}
          <span aria-hidden="true">*</span></label
        >
        <input
          id="address"
          class="billing-details__input"
          type="text"
          formControlName="address"
        />
      </div>
      <div
        class="billing-details__field-container billing-details__city-container"
      >
        <label for="city"
          >{{ content?.fields.city }} <span aria-hidden="true">*</span></label
        >
        <input
          id="city"
          class="billing-details__input"
          type="text"
          formControlName="city"
        />
      </div>
      <div
        class="billing-details__field-container billing-details__postal-code-container"
      >
        <label for="postal-code">{{ content?.fields.postalCode }} *</label>
        <input
          id="postal-code"
          class="billing-details__input"
          type="text"
          formControlName="postalCode"
        />
      </div>
      <div class="billing-details__field-container">
        <label for="country"
          >{{ content?.fields.country }}
          <span aria-hidden="true">*</span></label
        >
        <app-select-country
          (changed)="countryChanged($event)"
          [defaultCountry]="defaultCountry"
          labelForId="country"
        ></app-select-country>
      </div>
    </div>

    <div class="default-payment-method" *ngIf="!addPaymentMethod">
      <ng-container *ngIf="defaultPaymentMethod$ | async as paymentMethod">
        <div class="default-payment-method__heading">
          {{
            content?.fields?.defaultPaymentMethod | findResource: 'dpm.title'
          }}
        </div>
        <span class="card-brand">{{ paymentMethod.card.brand }}:</span>
        <span class="card-number">
          **** **** {{ paymentMethod.card.last4 }}</span
        >
        <span class="card-valid-until">
          {{
            content?.fields?.defaultPaymentMethod
              | findResource: 'dpm.validUntilText'
          }}: {{ paymentMethod.card.exp_month }} /
          {{ paymentMethod.card.exp_year }}
        </span>
        <button
          class="default-payment-method__add-new"
          (click)="addNewPaymentMethod()"
        >
          {{
            content?.fields?.defaultPaymentMethod
              | findResource: 'dpm.addNewCardInfo'
          }}
        </button>
      </ng-container>
    </div>

    <div
      class="card-input"
      [ngClass]="{
        'card-input--visible': addPaymentMethod || !hasDefaultPaymentMethod
      }"
    >
      <label for="card-element"
        >{{ content?.fields.cardInformation }}
        <span aria-hidden="true">*</span></label
      >
      <div id="card-element" #cardElement>
        <!-- A Stripe Element will be inserted here. -->
      </div>

      <!-- Used to display Element errors. -->
      <span class="input-error">{{ cardErrors }}</span>
    </div>

    <div class="summary">
      <span class="summary__label">{{ content?.fields.totalText }}: </span>
      <span class="summary__sum"
        >{{ selectedPlanTotal | async }}€ /{{
          (globalContent$ | async)?.fields.unitMonth
        }}</span
      >
    </div>

    <div class="legal-agreement">
      <input
        class="legal-agreement__input--checkbox"
        type="checkbox"
        id="legal-agreement"
        formControlName="legalAgreement"
      />
      <label class="legal-agreement__label--checkbox" for="legal-agreement">
        {{ content?.fields.legalAgreementText }}
      </label>
      <span class="input-error" *ngIf="hasError(legalAgreement, 'required')">
        {{ content?.fields.legalAgreementErrorText }}
      </span>
    </div>

    <div class="updated-terms" *ngIf="showUpdatedTermsControl">
      <input
        class="updated-terms__input--checkbox"
        type="checkbox"
        id="updated-terms"
        formControlName="updatedTerms"
      />
      <label class="updated-terms__label--checkbox" for="updated-terms">
        {{ content?.fields.updatedTermsText }}
      </label>
      <span class="input-error" *ngIf="hasError(updatedTerms, 'required')">
        {{ content?.fields.legalAgreementErrorText }}
      </span>
    </div>

    <div class="pay__button-container">
      <button
        class="pay__button"
        type="submit"
        [ngClass]="{
          'pay__button--loading': loading,
          'pay__button--disabled': paymentForm.invalid
        }"
      >
        {{ content?.fields.buttonText }}
      </button>
    </div>

    <p class="pay__smallprint">
      {{ content?.fields.smallprint }}
    </p>
  </form>
</div>
